@if (showSpinner) {
  <div class="highcharts-spinner"></div>
}
<div [style]="!showSpinner ? 'display: block' : 'display: none'">
  <div class="wdr" id="wdr-container"></div>
  <div id="highchartsContainer"></div>
</div>
